import { createSelector } from '@reduxjs/toolkit'

export const libraryPicksSelector = state => state.libraryPicksReducer

export const getFetching = () =>
  createSelector(libraryPicksSelector, libraryPicks => libraryPicks.fetching)

export const getLibraryPicks = () =>
  createSelector(
    libraryPicksSelector,
    libraryPicks => libraryPicks.libraryPicks
  )

export const getHasMore = () =>
  createSelector(libraryPicksSelector, libraryPicks => libraryPicks.hasMore)
